import { CancelContent, ICancelContentProps } from '@components/display/dialogs';
import { Dialog, DialogProps } from '@mui/material';

const CancelDeleteDialog = ({ title, subtitle, primary, secondary, ...props }: DialogProps & ICancelContentProps) => {
    return (
        <Dialog
            {...props}
            slotProps={{
                paper: { className: 'min-h-[300px] justify-center max-w-[828px] w-[828px] min-w-[unset] rounded-2xl' },
            }}
        >
            <CancelContent title={title} subtitle={subtitle} primary={primary} secondary={secondary} />
        </Dialog>
    );
};

export { CancelDeleteDialog };
